import React, { useCallback, useEffect, useRef, useState } from 'react';
import SvgExportRender from "./components/SvgExportRender";
import { Card, SerializableCard } from './models/Card';
import { Deck } from './models/Deck';
import { StackCard } from './models/StackCard';

function RendererOnlyApp() {

    const [deck, setDeck] = useState<Deck>(new Deck());
    const [isRequestedExportSvg, setIsRequestedExportSvg] = useState(false);

    const headerLine1Value = useRef("");
    const headerLine2Value = useRef("");
    const fileName = useRef("");

    const handleDeckUpdate = useCallback((event: CustomEvent) => {
        const request = event.detail as RendererRequest;
        const deck = parseServerDefinedDeck(request.deckText);

        headerLine1Value.current = request.line1Text;
        headerLine2Value.current = request.line2Text;
        fileName.current = request.fileName;
        setDeck(deck);
        setIsRequestedExportSvg(true);
        window.dispatchEvent(new Event('osicastartrenderer'));
    }, []);

    useEffect(() => {
        window.addEventListener('osicarenderdeck', handleDeckUpdate as EventListenerOrEventListenerObject);

        return () => {
            window.removeEventListener('osicarenderdeck', handleDeckUpdate as EventListenerOrEventListenerObject);
        };
    }, []);

    const handleOnSvgExported = useCallback(() => {
        setIsRequestedExportSvg(false);
        window.dispatchEvent(new Event('osicarendererexported'));
    }, []);

    return <SvgExportRender
        isRenderEnabled={isRequestedExportSvg}
        deck={deck}
        headerLine1Value={headerLine1Value}
        headerLine2Value={headerLine2Value}
        fileName={fileName}
        onExported={handleOnSvgExported} />
}
export default RendererOnlyApp;

function parseServerDefinedDeck(obj: string) {
    const deckJson = JSON.parse(obj) as ServerDefinedDeck;
    if (Array.isArray(deckJson.normalCards) && Array.isArray(deckJson.favoriteCards)) {
        const normalCards = deckJson.normalCards.map(x => new StackCard(Card.loadFromSerializableCard(x.card), x.count));
        const favoriteCards = deckJson.favoriteCards.map(x => Card.loadFromSerializableCard(x));
        return new Deck(favoriteCards, normalCards);
    }
    return new Deck([], []);
}

interface ServerDefinedDeck {
    normalCards: { card: SerializableCard, count: number }[];
    favoriteCards: SerializableCard[];
    totalCount: number;
    isErrorTotalCount: boolean;
    errorCards: SerializableCard[]
}

export interface RendererRequest {
    fileName: string;
    line1Text: string;
    line2Text: string;
    deckText: string;
}